import React, { Fragment } from 'react';

import AuthorAvatar from '../page/AuthorAvatar';
import TettraEditor from '../../tettra-editor/components/TettraEditor';

import contentToEditorState from '../../tettra-editor/utilities/contentToEditorState';

import useUser from '../../hooks/useUser';

const AskerName = ({ asker_id }) => {
    const user = useUser(asker_id);
    if (!user) return null;

    return (
        <Fragment>
            <span className="black bold">{user.display_name}</span>
            {' '}
asked a question
        </Fragment>
    );
};

const QuestionDescription = ({ detailsContentState }) => {
    if (!detailsContentState) return null;

    const READ_ONLY = true;
    const editorState = contentToEditorState(JSON.parse(detailsContentState), READ_ONLY);
    if (!editorState.getCurrentContent().getPlainText().trim()) return null;

    return (
        <TettraEditor
            config={{
                editorIdentifier: 'DraftQuestionShow',
                readOnly: READ_ONLY,
                enableSmallEditor: true,
            }}
            editorState={editorState}
            updateModel={() => null}
        />
    );
};

export default ({ question }) => {
    const { asker_id, title, details_content_state } = question;
    return (
        <div className="inline-suggestion">
            <div className="flex">
                <div className="flex-none mr1">
                    <AuthorAvatar noLink customClass="left post-avatar" userId={asker_id} />
                </div>
                <div className="flex-auto gray">
                    <AskerName asker_id={asker_id} />
                    <h4 className="m0 mt2">{title}</h4>
                    <QuestionDescription detailsContentState={details_content_state} />
                </div>
            </div>
        </div>
    );
};
